// Copyright © 2026 Atomic.io Limited. All rights reserved.

// `AtomicSDK.observeSDKEvents` accepts a single callback, so the app registers one observer and fans its events out
// to any number of subscribers.
const subscribers = new Set()

/**
 * @param {(event: object) => void} callback Called with every SDK event.
 * @returns A function that removes the subscription.
 */
export const subscribeToSDKEvents = callback => {
  subscribers.add(callback)
  return () => {
    subscribers.delete(callback)
  }
}

/**
 * @param {object} event An event received from `AtomicSDK.observeSDKEvents`.
 */
export const publishSDKEvent = event => {
  subscribers.forEach(callback => callback(event))
}
